import api from '../api';
function avatar(userId) {
    return api.defaults.baseURL + "/api/user/avatar/" + userId;
}
function monogram(userName) {
    return userName.split(' ').map(function (i) { return i[0]; }).join('');
}
var Claims = /** @class */ (function () {
    function Claims() {
    }
    Claims.User = "User";
    Claims.Admin = "Admin";
    Claims.Manager = "Manager";
    Claims.CreateOtherTask = "CreateOtherTask";
    return Claims;
}());
export { Claims, avatar, monogram };



//////////////////
// WEBPACK FOOTER
// ./src/models/User.ts
// module id = 38
// module chunks = 0